import React, { createContext, useContext, useMemo, type ReactNode } from 'react';

type FeaturesContext = {
	isShareButtonEnabled: boolean;
	isPresenceEnabled: boolean;
	issueViewInteraction: 'default' | 'openNewTab';
	isOnboardingEnabled: boolean;
	featureView: 'list' | 'list-embed' | 'software-list' | 'software-list-embed';
	inviteButtonInteraction: 'default' | 'openNewTab';
	typeSelectInteraction: 'default' | 'openNewTab';
	hasFilterCustomFields: boolean;
	hasCreateSubtask: boolean;
	canCreateIssues: boolean;
	isSoftwareFieldsEnabled: boolean;
	isBusinessFieldsEnabled: boolean;
	isScrumProject: boolean;
};

const defaultFeaturesContext: FeaturesContext = {
	isShareButtonEnabled: true,
	isPresenceEnabled: true,
	issueViewInteraction: 'default',
	isOnboardingEnabled: true,
	featureView: 'list',
	inviteButtonInteraction: 'default',
	typeSelectInteraction: 'default',
	hasFilterCustomFields: true,
	hasCreateSubtask: true,
	canCreateIssues: true,
	isSoftwareFieldsEnabled: false,
	isBusinessFieldsEnabled: true,
	isScrumProject: false,
};

const ListFeaturesContext = createContext<FeaturesContext>(defaultFeaturesContext);

const useJWMListFeatures = () => useContext(ListFeaturesContext);

type Props = Partial<FeaturesContext> & {
	children: ReactNode;
};

const ListFeaturesProvider = ({ children, ...props }: Props) => {
	const value = useMemo(() => ({ ...defaultFeaturesContext, ...props }), [props]);

	return <ListFeaturesContext.Provider value={value}>{children}</ListFeaturesContext.Provider>;
};

export { ListFeaturesProvider, useJWMListFeatures };
